module.exports = __webpack_public_path__ + "static/media/award.9217c76c.svg";